import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {TaskOutboundContainerModel} from "../../../../../../../models/aggregates/alg/cc/task";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
  
@Injectable({providedIn: "root"})
export class TaskOutboundService extends BaseApiTemplateService<TaskOutboundContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'outbound-tasks';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'outbound-tasks';
    this.httpClient = http;
  }
}